// venn图
import ChartTemplate from '../ChartTemplate';
import ChartOptionBuilder from '@/plugins/ChartOptionBuilder';
import { exportSVG, paramConvert } from '@/plugins/chart';
import $ from '@/assets/jquery/jquery-vendor.js';
import '@/assets/jvenn/canvas2svg.js';
import '@/assets/jvenn/jvenn.js';

let chart;
export default {
  extends: ChartTemplate,
  props: {
    formButtons: {
      type: Array,
      default: function () {
        return [{ code: 'downCsv', name: '下载csv', text: true, click: () => this.onExportCSV() }]
      }
    }
  },
  data () {
    return {
      extCPT: () => import('./ExtendComponent.vue'),
      extCPTProps: {chartElId: this.chartContainerId || 'chartContainer', embed: this.embed, rstVisible: false }
    }
  },
  methods: {
    initOption () {
      let defaultChartOption = new ChartOptionBuilder(this.tool.type, this.dataSource, this.config).get();
      this.Utility.deepMerge(this.chartOption, defaultChartOption, this.paramOption);
    },
    initOptionAfter () {
      let $this = this
      let option = {
        fnClickCallback: function () {
          if (!$(`#${$this.chartElId}-numberClickRst`).length) return
          let value = `在[${this.listnames.join(',')}]中的相同项列表：`;
          value += '\n' + this.list.join('\n');
          $(`#${$this.chartElId}-numberClickRst`).val(value);
        }
      }
      this.Utility.deepMerge(this.chartOption, option);
    },
    initChart () {
      chart = $(`#${this.chartElId}`).jvenn(this.chartOption);
      this.$set(this.extCPTProps, 'rstVisible', this.chartOption.rstVisible)
      $(`#${this.chartElId}-module-export`).hide();
      // 添加修改名称事件
      $(`[id^=${this.chartElId}-label]`).click((e) => {
        let srcName = e.target.innerText;
        this.$message.prompt('请输入新的列表名称', srcName, (newName) => {
          let names = this.dataSource[0];
          let srcIndex = names.indexOf(srcName);
          names[srcIndex] = newName;
          let defaultChartOption = new ChartOptionBuilder(this.tool.type, this.dataSource, this.config).get();
          this.chartOption.series = defaultChartOption.series;
          this.initChart();
        })
      });
    },

    onParamFormChanged (e, item) {
      this.paramFormData[item.code] = e;
      let r1 = this.onParamFormChangedBefore(e, item);
      if (r1 === false) return;
      let value = paramConvert(item.code, e);
      let option = value;
      if (item.optionCode) option = JSON.parse(item.optionCode.replaceAll('\\${value}', value));
      this.Utility.deepMerge(this.chartOption, option);
      this.initChart();
    },

    // =============== 导出
    onExport () {
      let svgNode = $(`#${this.chartElId}-canvasEllipse`).children('svg')[0];
      let w = svgNode.width.baseVal.value, h = svgNode.height.baseVal.value;
      this.exportDialogVisible = true;
      this.$nextTick(() => this.$refs.exportDialog.setSourceSize({ width: w, height: h }));
    },
    onExportOk (formData) {
      let svgNode = chart.getSVG();
      svgNode.setAttribute('fillColor', '#FFFFFF');
      exportSVG(svgNode, { ...formData, filename: this.exportFileName, venn: true });
      this.exportDialogVisible = false;
    },
    onExportCSV () {
      chart.getCSV(this.exportFileName);
    },
    getSvg () {
      return chart.getSVG();
    }
  }
}

/*
$('#chartVenn').jvenn({
        series: this.componentData,
fnClickCallback: function () { // 数字点击事件
  var value = "";
  if (this.listnames.length == 1) {
    value += "Elements only in ";
  } else {
    value += "Common elements in ";
  }
  for (let name in this.listnames) {
    value += this.listnames[name] + " ";
  }
  value += ":\n";
  for (let val in this.list) {
    value += this.list[val] + "\n";
  }
  alert(value);
},
exporting: false, // 是否启用导出
displayStat: true, // 是否显示下方的柱形图
displayMode: 'edwards', // 显示成另外一种图形（丑）
colors: ["rgb(0,102,0)", "rgb(90,155,212)", "rgb(241,90,96)", "rgb(250,220,91)", "rgb(255,117,0)", "rgb(192,152,83)"], // 必须使用rgb格式
fontFamily: 'Arial', // 字体
fontSize: '18px', // 字体大小
shortNumber: false, // 当内容太大的时候就显示问号
disableClick: true, // 禁止点击
rstVisible: true, // 是否显示点击后的结果
});
*/